"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppConstants = /** @class */ (function () {
    function AppConstants() {
    }
    AppConstants.isSubscriber = function (connectionRole) {
        return connectionRole.toLowerCase() === 'subscriber';
    };
    AppConstants.isModerator = function (connectionRole) {
        return connectionRole.toLowerCase() === 'moderator';
    };
    AppConstants.isOk = function (status) {
        return status.toLowerCase() === 'ok';
    };
    AppConstants.PARTICIPANTS_PER_PAGE = 6;
    AppConstants.BENCH_MEMBER_PARTICIPANTS_PER_PAGE = 6;
    AppConstants.COURT_STAFF_PARTICIPANTS_PER_PAGE = 6;
    AppConstants.OTHER_PARTICIPANTS_PER_PAGE = 12;
    AppConstants.MUTED_MESSAGE_TITLE = 'vc.notification.muted';
    AppConstants.UNMUTED_MESSAGE_TITLE = 'vc.notification.unmuted';
    AppConstants.MUTED_MESSAGE_ALL = 'vc.notification.muted_all.message';
    AppConstants.MUTED_MESSAGE = 'vc.notification.muted.message';
    AppConstants.UNMUTED_MESSAGE = 'vc.notification.unmuted.message';
    AppConstants.VIDEO_ON_MESSAGE_TITLE = 'vc.notification.videoOn';
    AppConstants.VIDEO_OFF_MESSAGE_TITLE = 'vc.notification.videoOff';
    AppConstants.VIDEO_ON_MESSAGE = 'vc.notification.videoOn.message';
    AppConstants.VIDEO_ON_MESSAGE_ALL = 'vc.notification.videoOn_all.message';
    AppConstants.VIDEO_OFF_MESSAGE = 'vc.notification.videoOff.message';
    return AppConstants;
}());
exports.AppConstants = AppConstants;
//# sourceMappingURL=constants.js.map